module.exports = __webpack_public_path__ + "static/img/jslogo.a537a55.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/introduce/images/jslogo.png
// module id = q5nE
// module chunks = 21